const state = () => ({
    show: false,
    mobilePhone: "",
});

const getters = {
    getStremaState(state) {
        return state;
    },
};

const actions = {};

const mutations = {
    setStremaState(state, payload) {
        state.show = payload.show;
        state.mobilePhone = payload.mobilePhone;
    },

    setStremaStateShow(state, payload) {
        state.show = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
